<template>
    <div class="agreement-signatories">
        <div class="form-group has-feedback" v-for="(signatory, index) in signatories">
            <label>Lease Holder</label>

            <div class="input-group">
                <input class="form-control" required v-model="signatory.name"
                       v-bind:name="'AccountAgreement[signatories][' + ( index + 1 ) + ']'">
                <span v-if="!multiSignature" class="input-group-btn">
                    <button class="btn btn-warning" type="button" v-on:click="removeSignatory(index)">Remove</button>
                </span>
            </div>
        </div>

        <div v-if="!multiSignature" class="text-right">
            <a v-on:click="addSignatory">
                Add Lease Holder
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            multiSignature: {
                required: true,
                type: Boolean
            },
        },

        data() {
            return {
                signatories: []
            };
        },
        methods: {
            addSignatory(){
                this.signatories.push( {
                    name: ''
                } );
            },
            removeSignatory( index ){
                this.signatories.splice( index, 1 )
            }
        }
    }
</script>